import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import {
  NuvemEnvioCreateLabelsRequestDto,
  NuvemEnvioCreateLabelsResponseDto,
} from '@tiendanube/common';
import { useAppDispatch } from 'App/store';
import {
  getNuvemEnvioAsyncLabelsData,
  getNuvemEnvioAsyncLabelsStatus,
} from '../../ordersSlice/ordersSelectors';
import {
  createNuvemEnvioAsyncLabels as createNuvemEnvioAsyncLabelsAction,
  resetCreateNuvemEnvioAsyncLabels as resetCreateNuvemEnvioAsyncLabelsAction,
} from '../../ordersSlice/ordersSlice';

export interface UseCreateAsyncNuvemEnvioLabelsResult {
  createNuvemEnvioAsyncLabels: (
    labels: NuvemEnvioCreateLabelsRequestDto,
  ) => Promise<NuvemEnvioCreateLabelsResponseDto>;
  data: NuvemEnvioCreateLabelsResponseDto;
  status: {
    isIdle: boolean;
    isLoading: boolean;
    isError: boolean;
    isSuccess: boolean;
  };
  resetNuvemEnvioAsyncLabels: () => void;
}

function useCreateAsyncNuvemEnvioLabels(): UseCreateAsyncNuvemEnvioLabelsResult {
  const dispatch = useAppDispatch();

  const data = useSelector(getNuvemEnvioAsyncLabelsData);
  const status = useSelector(getNuvemEnvioAsyncLabelsStatus);

  const createNuvemEnvioAsyncLabels = useCallback(
    async (
      request: NuvemEnvioCreateLabelsRequestDto,
    ): Promise<NuvemEnvioCreateLabelsResponseDto> => {
      const response = await dispatch(
        createNuvemEnvioAsyncLabelsAction({
          fulfillmentOrderIds: request.fulfillmentOrderIds,
          nuvemEnvioCarrierId: request.nuvemEnvioCarrierId,
        }),
      ).unwrap();

      return response;
    },
    [dispatch],
  );

  const resetNuvemEnvioAsyncLabels = useCallback(() => {
    dispatch(resetCreateNuvemEnvioAsyncLabelsAction());
  }, [dispatch]);

  return {
    createNuvemEnvioAsyncLabels,
    resetNuvemEnvioAsyncLabels,
    data,
    status,
  };
}

export default useCreateAsyncNuvemEnvioLabels;
